import { getLocale } from "@/utils/locale";
import { createI18n } from "vue-i18n";
import de from "./de.json";
import en from "./en.json";
import es from "./es.json";
import fr from "./fr.json";
import nl from "./nl.json";

type MessageSchema = typeof fr;

export const i18n = createI18n<[MessageSchema], "en" | "fr" | "de" | "nl" | "es">({
  // eslint-disable-next-line @typescript-eslint/no-deprecated -- v11 defaults to legacy mode; the option goes away with v12
  legacy: false,
  locale: getLocale(),
  fallbackLocale: "en",
  messages: {
    en,
    fr,
    de,
    nl,
    es,
  },
});
